
import { ProfessionData } from '../types/professionTypes';

export const plombier: ProfessionData = {
  title: "Plombier",
  slug: "plombier",
  description: "Solutions de recyclage adaptées aux déchets de plomberie",
  icon: "Wrench",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Métaux non ferreux",
      description: "Les tuyaux en cuivre, robinets en laiton et autres composants métalliques ont une grande valeur en recyclage.",
      solutions: ["Collecte sur site", "Rachat au poids"],
      environmentalBenefit: "Réduction de l'extraction minière et valorisation des ressources"
    },
    {
      type: "PVC et plastiques",
      description: "Les tuyaux en PVC, raccords et gaines représentent un volume important de déchets recyclables.",
      solutions: ["Benne de tri spécifique", "Transformation en granulés"],
      environmentalBenefit: "Économie circulaire des plastiques techniques"
    },
    {
      type: "Déchets d'équipements sanitaires",
      description: "Baignoires, toilettes, éviers et autres équipements sanitaires en fin de vie.",
      solutions: ["Collecte des encombrants", "Démantèlement et valorisation"],
      environmentalBenefit: "Valorisation matière et réduction des déchets"
    }
  ],
  relatedProfessions: ["chauffagiste", "electricien", "carreleur"]
};
